<template lang="pug">
  collapsed-data-sections(:sections="lvl1")
</template>
<script>
import { mapGetters, } from 'vuex'
import record from '@/constants/tooltips/record'
import CollapsedDataSections from '@/components/record-details/CollapsedDataSections'

export default {
  components: { CollapsedDataSections, },
  data () {
    return {
      tooltips: record,
    }
  },
  computed: {
    lvl1 () {
      return [
        {
          title: `LEI Code  ${this.lei}`,
          data: this.entityDetails,
          property: 'showEntityDetails',
          tip: this.tooltips.sectionEntity,
          sectionDisabledMsg: this.entitySectionIsBlocked
            ? `The Entity section cannot be challenged if Status is "${this.recordRegistrationStatus}".`
            : undefined,
        },
        {
          title: 'Addresses',
          data: this.addresses,
          property: 'showAddresses',
          tableLayout: 'address',
          tip: this.tooltips.sectionAddresses,
          sectionDisabledMsg: this.addressesSectionIsBlocked
            ? `The Addresses section cannot be challenged if Status is "${this.recordRegistrationStatus}".`
            : undefined,
        },
        {
          title: 'Registration details',
          data: this.registrationDetails,
          property: 'showRegistrationDetails',
          tip: this.tooltips.sectionRegistration,
        },
        // {
        //   title: 'LEI Record Data History (Timeline)',
        //   data: this.modifications,
        //   property: 'showHistoricalData',
        //   tableLayout: 'data-history',
        //   isHistorical: true
        // }
      ]
    },

    ...mapGetters('record', [
      'lei',
      'recordRegistrationStatus',
      'entityDetails',
      'entitySectionIsBlocked',
      'addresses',
      'addressesSectionIsBlocked',
      'registrationDetails',
    ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
</style>



// WEBPACK FOOTER //
// src/components/record-details/RecordInfo.vue